const CARD_PRODUCTS = ['CREDIT_CARD', 'DEBIT_CARD'] as const

const BANKING_PRODUCTS = [
  'CASH',
  'DEPOSIT',
  'CREDIT',
  ...CARD_PRODUCTS,
  'LOAN',
  'INVESTMENT',
] as const

export type BankingProductType = (typeof BANKING_PRODUCTS)[number]

export type CardProductType = (typeof CARD_PRODUCTS)[number]

/**
 * Tipo único de tarjeta anterior a la separación entre crédito y débito. Lo siguen enviando al
 * remote de movimientos los shells móviles ya instalados. Quitar cuando no quede ninguno.
 */
export const LEGACY_CARD_PRODUCT_TYPE = 'CARD'

export const isCardProductType = (productType?: string): boolean =>
  CARD_PRODUCTS.includes(productType as CardProductType) || productType === LEGACY_CARD_PRODUCT_TYPE

const INVESTMENT_PRODUCTS = [
  'FUND',
  'FIXED_INCOME',
  'VARIABLE_INCOME',
  'ETF',
  'PENSION',
  'EPSV',
  'DERIVATIVE',
  'WARRANT',
  'OTHER_PRODUCT_LIFE_SAVINGS_INSURANCE',
  'OTHER_PRODUCT_GENERAL_PERSONAL_INSURANCE',
  'OTHER_PRODUCT_PENSION_PLANS',
  'OTHER_PRODUCT_ALTERNATIVE_INVESTMENTS',
  'OTHER_PRODUCT_SOCIMIS',
] as const

export type InvestmentProductType = (typeof INVESTMENT_PRODUCTS)[number]

export type AlternativeInvestmentProductSubType =
  | 'REAL_ASSETS'
  | 'INFRASTRUCTURE'
  | 'REAL_ESTATE'
  | 'OTHER'
  | 'PRIVATE_DEBT'
  | 'PRIVATE_EQUITY'
  | 'VENTURE_CAPITAL'

export type ProductType = Exclude<BankingProductType, 'INVESTMENT'> | InvestmentProductType

export type DistributionProductType =
  | Exclude<BankingProductType, CardProductType | 'LOAN' | 'INVESTMENT'>
  | InvestmentProductType

export const productTypeThemeToken: Partial<Record<ProductType, string>> = {
  LOAN: 'category2',
  CASH: 'category3',
  DEPOSIT: 'category4',
  CREDIT: 'category5',

  FUND: 'graph-02',
  FIXED_INCOME: 'graph-03',
  VARIABLE_INCOME: 'graph-04',
  PENSION: 'graph-05',
  EPSV: 'graph-07',
  DERIVATIVE: 'graph-08',
  WARRANT: 'graph-09',
  ETF: 'graph-10',

  OTHER_PRODUCT_LIFE_SAVINGS_INSURANCE: 'graph-c-300',
  OTHER_PRODUCT_PENSION_PLANS: 'graph-c-100',
  OTHER_PRODUCT_ALTERNATIVE_INVESTMENTS: 'graph-c-700',
  OTHER_PRODUCT_SOCIMIS: 'graph-c-1000',
}
